import lifeData from './lifeData';
import healthData from './healthData';
import rentersData from './rentersData';
import homeData from './homeData';
import disabilityData from './disabilityData';
import autoData from './autoData';
import moreData from './moreData';

export default [
  lifeData,
  disabilityData,
  healthData,
  rentersData,
  homeData,
  autoData,
  moreData
];



// WEBPACK FOOTER //
// ../src/templates/MainNav/data/products/index.js